const PUBLIC_EXACT_PATHS = new Set([
  "/",
  "/login",
  "/signup",
  "/verification",
  "/reset-password",
  "/checkout",
  "/auth/shopify",
]);

/** Paths reachable without a Firebase session (share links, checkout, invite auth, etc.). */
export function isPublicAppPath(pathname) {
  if (!pathname) return false;
  const path = (pathname.split("?")[0].replace(/\/+$/, "") || "/").toLowerCase();

  if (PUBLIC_EXACT_PATHS.has(path)) return true;
  if (path.startsWith("/checkout/")) return true;
  if (path.startsWith("/share/")) return true;
  if (path.startsWith("/s/")) return true;
  if (path.startsWith("/demos/")) return true;
  if (path.startsWith("/book/")) return true;
  if (path.startsWith("/appointment/")) return true;
  if (/^\/users\/[^/]+\/user_auth$/.test(path)) return true;

  return false;
}

/**
 * Same-origin in-app path only. Blocks open redirects (`//`, other hosts).
 * Accepts a relative path (`/console/alerts`) or an absolute URL on this origin.
 */
export function sanitizeAppReturnPath(raw, origin) {
  if (!raw || typeof raw !== "string") return null;
  let path = raw.trim();
  const here =
    origin ||
    (typeof window !== "undefined" && window.location
      ? window.location.origin
      : "");

  if (/^https?:\/\//i.test(path)) {
    try {
      const parsed = new URL(path);
      if (here && parsed.origin !== here) return null;
      path = `${parsed.pathname}${parsed.search}${parsed.hash}`;
    } catch (_) {
      return null;
    }
  }

  if (!path.startsWith("/") || path.startsWith("//")) return null;
  const pathname = path.split("?")[0].split("#")[0].toLowerCase();
  if (pathname === "/login" || pathname.startsWith("/login/")) return null;
  if (pathname === "/pwa" || pathname.startsWith("/pwa/")) return null;
  return path;
}

export function buildLoginRedirectPath(returnUrl) {
  const path = sanitizeAppReturnPath(
    returnUrl ||
      (typeof window !== "undefined"
        ? `${window.location.pathname}${window.location.search}`
        : "/")
  );
  if (!path) return "/login";
  return `/login?returnTo=${encodeURIComponent(path)}`;
}

/** Relative path for history.push after auth. Prefers returnTo, then legacy redirectURL. */
export function resolvePostLoginPath(queryParams, fallbackPath) {
  const raw =
    (queryParams && (queryParams.returnTo || queryParams.redirectURL)) || "";
  return sanitizeAppReturnPath(raw) || fallbackPath || "/";
}
